// extracted by mini-css-extract-plugin
export default {"DealARIADescriptor":"DealARIADescriptor_DealARIADescriptor__MDljZ"};